export const border = {
    strong: "border-[var(--diagram-border-strong)]",
    weak: "border-[var(--diagram-border-weak)]",
};

interface Props {
    color: keyof typeof border;
}

export const Border = (props: Props): JSX.Element => {
    const { color } = props;

    return (
        <hr
            className={[
                "border-[1px] border-solid",
                "self-stretch h-auto border-b-0 border-r-0",
                border[color],
            ].join(" ")}
        />
    );
};
